import { PortalzugriffDisplayModel } from '@/api/model-index';
import { PortalzugriffService } from '@/api/service-index';
import { AnfrageLiveSharingService } from '@/core/services/anfrage-live-sharing.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FabOffset, PreventableEvent } from '@progress/kendo-angular-buttons';

@Component({
  selector: 'app-live-users-dialog',
  templateUrl: './live-users-dialog.component.html',
  styleUrls: ['./live-users-dialog.component.scss']
})
export class LiveUsersDialogComponent {

  protected portalzugriffe: PortalzugriffDisplayModel[] = [];
  public livePortalzugriffe: any[] = [];

  constructor(protected anfrageLiveSharingService: AnfrageLiveSharingService, protected portalContextService: PortalContextService, protected portalzugriffService: PortalzugriffService, protected route: ActivatedRoute) {
    this.portalzugriffService.apiPortalzugriffAnfrageIdGet({anfrageId: this.portalContextService.CurrentAnfrage.id, "x-anfragescope": this.portalContextService.CurrentAnfrage.objektTyp}).subscribe(response => {
      this.portalzugriffe = response;
      
      this.anfrageLiveSharingService.livePortalzugriffeBehavior.asObservable().subscribe(values => {
        this.updateLivePortalzugriffe(values);
      })
      this.updateLivePortalzugriffe(this.anfrageLiveSharingService.livePortalzugriffe);
    })
  }

  public dialOpen = false;

  public xValue = 0;
  public yValue = 0;
  public offset: FabOffset = { x: `${this.xValue}px`, y: `${this.yValue}px` };

  public get text(): string {
    return this.anfrageLiveSharingService.livePortalzugriffe.length.toString();
  }

  public onDialOpen(): void {
    this.dialOpen = true;
  }

  public onDialClose(event: PreventableEvent): void {
    this.dialOpen = false;
  }

  updateLivePortalzugriffe(values: string[]) {
    let updatedList: any[] = [];

    values.filter(email => email != this.route.snapshot.data.user.username).forEach(email => {
      let foundUser = this.portalzugriffe.find(zugriff => zugriff.externerBenutzer?.username == email);
      if(foundUser) {
        updatedList.push({
          name: foundUser.externerBenutzer?.firstname + " " + foundUser.externerBenutzer?.lastname,
          initials: foundUser.externerBenutzer?.firstname?.charAt(0) + "" + foundUser.externerBenutzer?.lastname?.charAt(0)
        })
      }
      else {
        updatedList.push({
          name: email,
          initials: "?"
        })
      }
    })

    this.livePortalzugriffe = updatedList;
    (document.getElementById("blazor-anfrage-sharing") as HTMLElement)?.click();
  }
}
